import { PregnancyCompletion } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { dateFormatter, Translate } from '@dreryk/react-common';
import { Heading, SidePanelSlots, StyledFlex } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../../translations';

type GynecologicalInterviewPregnancyCompletionCategoryContentProps = {
   readonly pregnancyCompletionInterview: PregnancyCompletion;
};

export const GynecologicalInterviewPregnancyCompletionCategoryContent = (
   props: GynecologicalInterviewPregnancyCompletionCategoryContentProps
): JSX.Element => {
   const {
      pregnancyCompletionInterview: { pregnancyCompletionType, completionDate, description },
   } = props;
   return (
      <div>
         <Heading
            testId={'pregnancyCompletion'}
            content={visitPatientPregnancyStatusTranslationKeys.pregnancyCompletionType[pregnancyCompletionType]}
            type={'h3'}
            bold
         />
         <StyledFlex direction={'column'} gap={'12px'}>
            <span>
               <Translate>{visitPatientPregnancyStatusTranslationKeys.pregnancyCompletionDate}</Translate>
               {': '}
               {completionDate ? dateFormatter(completionDate) : '-'}
            </span>
            {description ? <SidePanelSlots.Expandable>{description}</SidePanelSlots.Expandable> : null}
         </StyledFlex>
      </div>
   );
};
